export default __webpack_public_path__ + "static/media/img-0096-china-full-face.6c99eec8.png";